import LilleSwitch from './lille-switch';

LilleSwitch.install = Vue => Vue.component(LilleSwitch.name, LilleSwitch);

export default LilleSwitch;


// WEBPACK FOOTER //
// ./src/packages/switch/index.js